import React from "react";
import { useLanguage } from "../store/slices/userSlice";

const Close = (props) => {
  const language = useLanguage();
  return (
    <>
      <style>
        {`
        .close {
          ${language === "ar" ? "left: 0;" : "right: 0;"}
        }
      `}
      </style>
      <div className="close-parent">
        <div className="close">

          {props.children}

        </div>
      </div>
    </>
  );
};

export default Close;
